import { useCallback, useState } from 'react'
import { useQuery } from '../../../../../hooks/useQuery'
import { ProposalViewTabEnum } from '../proposal-view.types'
import history from '../../../../../history'

type ReturnType = [{
  activeTab: ProposalViewTabEnum;
}, {
  onChangeActiveTab: (tabKey: string) => void,
}]

const TAB_QUERY_PARAM = 'tab'

export function useProposalViewTabs(): ReturnType {
  const query = useQuery()
  const defaultTab = query.get(TAB_QUERY_PARAM) as ProposalViewTabEnum ?? ProposalViewTabEnum.Search
  const [activeTab, setActiveTab] = useState<ProposalViewTabEnum>(defaultTab)

  const onChangeActiveTab = useCallback((tabKey: string) => {
    setActiveTab(tabKey as ProposalViewTabEnum)
    history.push({
      pathname: '/new', // TODO
      search: `?${TAB_QUERY_PARAM}=${tabKey}`,
    })
  }, [])

  return [{
    activeTab,
  }, {
    onChangeActiveTab,
  }]
}
